const mobileMenuOpenButton = document.querySelector('.js-mobile-menu-open');
const mobileMenuCloseButton = document.querySelector('.js-mobile-menu-close');
const mobileMenu = document.querySelector('.js-mobile-menu-container');

mobileMenuOpenButton?.addEventListener('click', function () {
  mobileMenu.classList.add('animate-mobile-menu');
});

mobileMenuCloseButton?.addEventListener('click', function () {
  mobileMenu.classList.remove('animate-mobile-menu');
});

mobileMenu?.querySelectorAll('a[href^="#"]').forEach(function (button) {
  button.addEventListener('click', function () {
    mobileMenu.classList.remove('animate-mobile-menu');
  });
});
